import { useCallback } from 'react';
import { useToast } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import { useOnlineBookingAnnouncements } from '../../hooks/useOnlineBookingAnnouncements';

/**
 * «نوبت آنلاین جدید — سه‌شنبه، ۲۸ مهر، ساعت ۱۰:۳۰» (PM-0382 §4.8).
 *
 * A part of the shell, like PaywallDialog: mounted once in ClinicLayout so the
 * desk hears about a patient's own booking on whatever screen it is working, and
 * renders nothing of its own. Which frames count, the de-duplication and the
 * permission gate are the hook's; this only words the sentence — the day and the
 * time on the CLINIC's clock and calendar (the formatters carry its zone) — and
 * shows it as an info toast: a fact, never an alarm.
 *
 * It names NO patient (DESIGN_CONCEPT §7, §13.2: no PHI in a toast). Who booked is
 * on the day list, which the hook has already told to re-read.
 */
export default function OnlineBookingToaster() {
  const toast = useToast();
  const { t, formatDate, formatTime } = useTranslation();

  const announce = useCallback(({ dateTime }) => {
    toast.info(dateTime
      ? t('reception.online.toast', {
        day: formatDate(dateTime, 'weekdayDayMonth'),
        time: formatTime(dateTime),
      })
      : t('reception.online.toastBare'));
  }, [toast, t, formatDate, formatTime]);

  useOnlineBookingAnnouncements(announce);
  return null;
}
